var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.468 14.206c-.423.936-.624 1.356-1.169 2.183-.757 1.157-1.83 2.6-3.155 2.608-1.178.011-1.482-.768-3.081-.754-1.6.005-1.935.768-3.115.757-1.323-.011-2.337-1.313-3.097-2.465-2.125-3.236-2.349-7.03-1.036-9.047.928-1.431 2.398-2.271 3.78-2.271 1.403 0 2.288.77 3.45.77 1.128 0 1.814-.773 3.441-.773 1.227 0 2.529.669 3.457 1.826-3.04 1.664-2.545 6.005.525 7.166zM12.251 3.92c.591-.757 1.039-1.83.879-2.921-.967.066-2.095.683-2.755 1.478-.597.727-1.092 1.807-.898 2.852 1.053.033 2.141-.594 2.774-1.41z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.166d2359c429115d8dc0f4e236307eb7.svg";
export { ForwardRef as ReactComponent };